import { UiIconComponent } from '@/ui/icon/ui-icon';
import { UiSpinnerComponent } from '@/ui/spinner/ui-spinner.component';
import { AsyncPipe } from '@angular/common';
import { Component, type OnInit, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdvizeoUiElementSize } from '../../interfaces/AdvizeoUi.interface';
import type { ProjectId } from '../../interfaces/Project.interface';
import { ProjectPipe } from '../../pipes/project.pipe';
import { AuthProvider } from '../../providers';
import { AppStatusProvider } from '../../providers/app-status/app-status.provider';
import { ProjectsProvider } from '../../providers/projects/projects.provider';
import { AdvizeoModalService } from '../../services/advizeo-modal.service';
import { ProjectSelectModalComponent } from './project-select-modal/project-select-modal';

@Component({
    styleUrls: ['./project-select.scss'],
    selector: 'project-select',
    templateUrl: 'project-select.html',
    imports: [UiSpinnerComponent, UiIconComponent, AsyncPipe, TranslatePipe, ProjectPipe]
})
export class ProjectSelectComponent implements OnInit {
    private _projectsProvider = inject(ProjectsProvider);
    private _appStatusProvider = inject(AppStatusProvider);
    private _modalService = inject(AdvizeoModalService);
    private _authProvider = inject(AuthProvider);

    hasNoProjects$!: Observable<boolean>;
    areProjectsLoaded$!: Observable<boolean>;
    isProjectDataLoading$!: Observable<boolean>;

    currentProjectId$!: Observable<ProjectId | null>;
    currentProjectLogoUrl$!: Observable<string | null>;

    ngOnInit() {
        this.hasNoProjects$ = this._projectsProvider.getUserProjects$().pipe(map(projects => projects.length === 0));
        this.areProjectsLoaded$ = this._projectsProvider.areProjectsLoaded$();

        this.currentProjectId$ = this._projectsProvider.getUserCurrentProjectId$();
        this.currentProjectLogoUrl$ = this._projectsProvider
            .getUserCurrentProject$()
            .pipe(map(project => (project ? project.logoUrl : null)));

        this.isProjectDataLoading$ = this._appStatusProvider.isProjectDataLoading$();
    }

    openModal() {
        this._modalService
            .openAdvizeoModal(ProjectSelectModalComponent, null, { size: AdvizeoUiElementSize.MEDIUM })
            .afterClosed()
            .then(projectId => {
                if (projectId) {
                    this._authProvider.changeProject(projectId);
                }
            });
    }
}
